import React from 'react';

import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

import LandingHelmet from '../../../components/LandingHelmet';
import { getMetaDescription } from '../../utils';

const SeoLocationHelmet: React.FC<{
  seoLocation: SeoLocation;
  overrideTitle?: string;
  overrideMetaDescription?: string;
  children?: React.ReactNode;
}> = ({ seoLocation, overrideTitle, overrideMetaDescription, children }) => {
  return (
    <LandingHelmet
      title={overrideTitle || seoLocation.details.seoDisplayTitle}
      metaDescription={overrideMetaDescription || getMetaDescription(seoLocation.details)}
    >
      <link rel="canonical" href={seoLocation.details.canonicalUrl} />
      {children}
    </LandingHelmet>
  );
};

export default SeoLocationHelmet;
